<template>
  <section>
    <div class="custom-loading-overlay" v-if="isLoading"></div>
    <img src="/imgs/loading.gif" class="loading-icon" v-if="isLoading" />

    <div id="showLoading" style="display: none;" @click="isLoading = true"></div>
    <div id="hideLoading" style="display: none;" @click="isLoading = false"></div>
  </section>
</template>
<script>
  export default {
    props: [
        'isActive'
    ],
    components: {},
    data() {
      return {
        isLoading: false
      }
    },
    created() {
      if (this.isActive) this.isLoading = this.isActive
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
.loading-icon {
  position: fixed;
  width: 270px;
  height: 180px;
  top: calc(50% - 135px);
  left: calc(50% - 90px);
  z-index: 99999;
}

.custom-loading-overlay {
  position: fixed;
  z-index: 99998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(100, 100, 100, .5);
}
</style>